import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Typography, Divider, Box, Button } from '@material-ui/core';
import { inject, observer } from 'mobx-react';

import ProductCard from '../../components/ProductCard';

import { formatDate } from '../../utils/date';

import RouterStore from '../../stores/RouterStore';

import { productsAlreadyScheduledStyles } from './styles';

const ProductsAlreadyScheduled = props => {
  const { productsAlreadyScheduledAndGroupedByDate } = props;

  const classes = productsAlreadyScheduledStyles(props);

  const handleReschedulingButtonClick = items => {
    const { routerStore } = props;
    const { history } = routerStore;

    const uuids = items.map(item => item.uuid);

    history.push('/agendar', { uuids });
  };

  return (
    <Grid item className={classes.container}>
      <Typography variant="h4" gutterBottom>
        Produtos já agendados
      </Typography>
      <Divider />
      <Box my={4}>
        {productsAlreadyScheduledAndGroupedByDate.map(element => {
          const date = Object.keys(element)[0];
          const items = Object.values(element)[0];

          return (
            <Box key={date} className={classes.wrapper}>
              <Box className={classes.header}>
                <Typography className={classes.scheduledDate}>
                  Agendado para: <b>{formatDate(date, 'DD/MM/YYYY')}</b>
                </Typography>
              </Box>
              <Grid container className={classes.root}>
                <Box className={classes.boxProductList}>
                  {items.map(item => (
                    <ProductCard
                      key={item.id}
                      product={item.product}
                      schedulingHistory={item.history}
                    />
                  ))}
                </Box>
              </Grid>
              {items[0].isCancelable && (
                <Box className={classes.footer}>
                  <Button
                    onClick={() => handleReschedulingButtonClick(items)}
                    variant="contained"
                    size="large"
                    fullWidth
                    disableElevation
                  >
                    <Typography>Reagendar</Typography>
                  </Button>
                </Box>
              )}
            </Box>
          );
        })}
      </Box>
    </Grid>
  );
};

ProductsAlreadyScheduled.propTypes = {
  productsAlreadyScheduledAndGroupedByDate: PropTypes.array.isRequired,
  routerStore: PropTypes.instanceOf(RouterStore).isRequired,
};

export default inject('routerStore')(observer(ProductsAlreadyScheduled));
